import React, { PureComponent } from "react";
import { Redirect } from "react-router-dom";

import { APP_PATH, CHANGE_PWD_PATH } from "../AppRoutes";
import LoginPage from "./login/LoginPage";
import { TokenData, User } from "../../types";
import { KeycloakContextProps } from "./keycloak/KeycloakProvider";

type AuthenticateProps = {
  /* Whether or not the user is authenticated so that they can use the app. */
  isAuthenticated: boolean;
  isFetching: boolean;
  lockOutDuration: number;
  // fetchingAuthStatus: PropTypes.func.isRequired,
  /* Message displayed if authentication failed. */
  failureMessage?: string | null;
  resetLockoutDuration: () => void;
  requestToken: (user: User) => Promise<any>;
  checkAuthStatus: () => boolean;
  initiatePasswordChange: boolean;
  fetchingAuthStatus: () => void;
  requestForgotPassword: (username: string) => Promise<any>;
  requestSignUp: (email: string) => Promise<any>;
  setFailureMessage: (message: string | null) => void;
  setTokens: (tokenData: TokenData) => void;
  loginSuccessful: (user: User) => void;
  keycloakContext: KeycloakContextProps;
};

type AuthenticateState = {
  showEmailSendSuccessfully: boolean;
};

export default class Authenticate extends PureComponent<
  AuthenticateProps,
  AuthenticateState
> {
  static defaultProps = {
    failureMessage: null,
  };

  state = {
    showEmailSendSuccessfully: false,
  };

  authenticate = (username: string, password: string) => {
    const { fetchingAuthStatus, requestToken } = this.props;

    if (username && password) {
      fetchingAuthStatus();
      requestToken({
        username,
        password,
        role: "",
        customerId: 0,
        fullname: "",
      });
    }
  };

  forgotPassword = (username: string) => {
    this.props
      .requestForgotPassword(username)
      .then(() => this.setState({ showEmailSendSuccessfully: true }))
      .catch(() => {});
  };

  signUp = (email: string) => {
    this.props
      .requestSignUp(email)
      .then(() => this.setState({ showEmailSendSuccessfully: true }))
      .catch(() => {});
  };

  toggleShowEmailSendSuccessfully = () => {
    this.setState({
      showEmailSendSuccessfully: !this.state.showEmailSendSuccessfully,
    });
  };

  createLoginPage = () => {
    const { isFetching, failureMessage, setFailureMessage } = this.props;
    const { showEmailSendSuccessfully } = this.state;

    return (
      <LoginPage
        forgotPassword={this.forgotPassword}
        authenticate={this.authenticate}
        signUp={this.signUp}
        isFetching={isFetching}
        failureMessage={failureMessage}
        showEmailSendSuccessfully={showEmailSendSuccessfully}
        toggleShowEmailSendSuccessfully={this.toggleShowEmailSendSuccessfully}
        setFailureMessage={setFailureMessage}
      />
    );
  };

  render() {
    const { checkAuthStatus, initiatePasswordChange } = this.props;

    if (initiatePasswordChange) {
      return <Redirect push to={CHANGE_PWD_PATH} />;
    }
    if (checkAuthStatus()) {
      return <Redirect push to={APP_PATH} />;
    }

    return this.createLoginPage();
  }
}
